import React, { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";

const BarcodeLabel = ({ code, batch }) => {
  const codeRef = useRef();
  const batchRef = useRef();
  const codeRef1 = useRef();
  const batchRef1 = useRef();

  useEffect(() => {
    JsBarcode(codeRef.current, code, {
      format: "CODE128",
      width: 0.85,
      height: 15,
      fontSize: 9,
      displayValue: true,
    });
    JsBarcode(batchRef.current, batch, {
      format: "CODE128",
      width: 0.5,
      height: 15,
      fontSize: 9,
      displayValue: true,
    });
    JsBarcode(codeRef1.current, code, {
      format: "CODE128",
      width: 0.85,
      height: 15,
      fontSize: 9,
      displayValue: true,
    });
    JsBarcode(batchRef1.current, batch, {
      format: "CODE128",
      width: 0.5,
      height: 15,
      fontSize: 9,
      displayValue: true,
    });
  }, [code, batch]);

  return (
    <div
      style={{
        width: "90mm",
        height: "20mm",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "2mm",
        // borderRadius: "5px",
        marginBottom: "1mm",
        
      }}
    >
      <div
        style={{
          paddingLeft: "20mm",
          width: "50%",
          textAlign: "center",
          display: "flex",
          marginTop: "2mm",
          flexDirection: "column",          
        }}
      >
        <svg ref={codeRef} />
        <div style={{ marginTop: -10 }}>
          <svg ref={batchRef} />
        </div>
      </div>

      <div
        style={{
          paddingLeft: "30mm",
          width: "50%",
          textAlign: "center",
          display: "flex",
          marginTop: "2mm",
          flexDirection: "column",
        }}
      >
        <svg ref={codeRef1} />
        <div style={{ marginTop: -10 }}>
          <svg ref={batchRef1} />
        </div>
      </div>
    </div>
  );
};

export default BarcodeLabel;
